import React from 'react';
import './HowToPlayModal.css';

interface TermsOfServiceModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const TermsOfServiceModal: React.FC<TermsOfServiceModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="how-to-play-overlay" onClick={onClose}>
      <div className="how-to-play-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>×</button>

        <h2>Terms of Service</h2>

        <div className="modal-section" style={{ textAlign: 'left', maxHeight: '60vh', overflowY: 'auto' }}>
          <p><strong>Last Updated:</strong> December 5, 2024</p>

          <h3>1. Acceptance of Terms</h3>
          <p>
            By accessing and playing Snap Pairs ("the Game"), you agree to be bound by these Terms of Service.
            If you do not agree to these terms, please do not use the Game.
          </p>

          <h3>2. Description of Service</h3>
          <p>
            Snap Pairs is a free tile-matching puzzle game. The Game includes both timed and untimed gameplay modes,
            a leaderboard system, and optional Google account integration for tracking scores.
          </p>

          <h3>3. User Accounts</h3>
          <p>
            To participate in leaderboards and save your progress, you may optionally sign in with your Google account.
            You are responsible for maintaining the confidentiality of your account credentials and for all activities
            that occur under your account.
          </p>

          <h3>4. Privacy and Data Collection</h3>
          <p>
            When you sign in with Google, we collect and store:
          </p>
          <ul>
            <li>Your Google email address</li>
            <li>Your display name</li>
            <li>Your profile picture (if available)</li>
            <li>Your game scores and statistics</li>
          </ul>
          <p>
            We do not sell, rent, or share your personal information with third parties. Your data is used solely
            to provide game functionality and leaderboard services.
          </p>

          <h3>5. Acceptable Use</h3>
          <p>You agree not to:</p>
          <ul>
            <li>Cheat, hack, or exploit the Game in any way</li>
            <li>Use automated tools or bots to play the Game</li>
            <li>Manipulate leaderboard scores or rankings</li>
            <li>Interfere with other players' enjoyment of the Game</li>
            <li>Attempt to access unauthorized areas of the Game's systems</li>
          </ul>

          <h3>6. Leaderboards</h3>
          <p>
            Leaderboards display scores from all authenticated users. We reserve the right to remove scores that
            appear fraudulent or that violate these Terms of Service. Leaderboard participation requires Google
            account authentication.
          </p>

          <h3>7. Intellectual Property</h3>
          <p>
            Snap Pairs and all related content, features, and functionality are owned by SnapPairs, LLC and are
            protected by copyright, trademark, and other intellectual property laws. You may not copy, modify,
            distribute, or create derivative works based on the Game without explicit permission.
          </p>

          <h3>8. Disclaimer of Warranties</h3>
          <p>
            The Game is provided "as is" and "as available" without warranties of any kind, either express or implied.
            We do not guarantee that the Game will be uninterrupted, secure, or error-free.
          </p>

          <h3>9. Limitation of Liability</h3>
          <p>
            To the maximum extent permitted by law, SnapPairs, LLC shall not be liable for any indirect, incidental,
            special, consequential, or punitive damages resulting from your use of or inability to use the Game.
          </p>

          <h3>10. Changes to Terms</h3>
          <p>
            We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately
            upon posting. Your continued use of the Game after changes constitutes acceptance of the modified terms.
          </p>

          <h3>11. Account Termination</h3>
          <p>
            We reserve the right to suspend or terminate your access to the Game at any time, with or without cause,
            including for violations of these Terms of Service.
          </p>

          <h3>12. Governing Law</h3>
          <p>
            These Terms of Service shall be governed by and construed in accordance with the laws of the United States,
            without regard to its conflict of law provisions.
          </p>

          <h3>13. Contact Information</h3>
          <p>
            For questions about these Terms of Service, please contact us through the Game's feedback channels.
          </p>

          <p style={{ marginTop: '2em', fontSize: '0.9em', color: '#888', textAlign: 'center' }}>
            Copyright © 2025 SnapPairs, LLC. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServiceModal;
